import React, { useEffect, useState } from "react";
import UserWrapper from "./CptCode.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import CptCodeServices from "../../api/CptCodeServices";
import GroupServices from "../../api/GroupServices";
import CptCodeForm from "../../components/cptCode/cptCodeForm";
import EncryptDecrypt from "../../api/EncryptDecrypt";

const CptCodeEdit = props => {
  const [editedData, setEditedData] = useState(undefined);
  const [insuranceList, setInsuranceList] = useState(undefined);
  const hasParam = props.match.params.id;
  useEffect(() => {
    if (hasParam) {
      const params = {
        id: hasParam
      };
      CptCodeServices.view(params).then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        setEditedData(data.data);
      });
    }
    GroupServices.insuranceList().then(res => {
      let data = EncryptDecrypt.decrypt(res.data);
      setInsuranceList(data.data);
    });
  }, []);

  const submitFormHandler = (data, action) => {
    setTimeout(() => {
      props.history.push("/cpt-code");
    }, 2000);
  };

  return (
    <UserWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          props={props}
          title="sidebar.cpt_code"
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard",
              url: "/dashboard"
            },
            {
              name: "sidebar.cpt_code",
              url: "/cpt-code"
            },
            {
              name: hasParam ? "action.edit" : "action.add"
            }
          ]}
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/cpt-code")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>

      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> {hasParam ? "Edit" : "Add"} Cpt
              Code
            </div>
          </div>
          <div className="roe-card-body">
            <CptCodeForm
              insuranceList={insuranceList}
              onSubmit={submitFormHandler}
              editedData={editedData}
              action={hasParam ? "edit" : "add"}
            />
          </div>
        </div>
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, null)(CptCodeEdit);
